import { PERSIST_STORE_NAME } from 'constants/app.constant'
import rootReducer, { AsyncReducers } from './rootReducer'
import { configureStore, Middleware } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { Reducer, AnyAction } from 'redux'
import { onSignOutSuccess } from './auth/sessionSlice'
import { resetRejectionDrafts } from 'views/movies/rejectionDraft'

// A reason typed in a Reject box is kept in memory per film (views/movies/rejectionDraft).
// Signing out must not leave it for the next person using this tab.
const forgetDraftsOnSignOut: Middleware = () => (next) => (action: any) => {
	if (action?.type === onSignOutSuccess.type) resetRejectionDrafts()
	return next(action)
}

const middlewares: Middleware[] = [forgetDraftsOnSignOut]

const persistConfig = {
	key: PERSIST_STORE_NAME,
	keyPrefix: '',
	storage,
	whitelist: ['auth', 'theme']
}

const store = configureStore({
	reducer: persistReducer(persistConfig, rootReducer() as any),
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			immutableCheck: false,
			serializableCheck: false,
		}).concat(middlewares),
	devTools: process.env.NODE_ENV === 'development',
}) as any

store.asyncReducers = {} as AsyncReducers

export const persistor = persistStore(store)

export const injectReducer = (key: string, reducer: Reducer<any, AnyAction>) => {
	if (store.asyncReducers[key]) {
		return false
	}
	store.asyncReducers[key] = reducer
	store.replaceReducer(persistReducer(persistConfig, rootReducer(store.asyncReducers) as any))
	persistor.persist()
	return store
}

export type AppDispatch = typeof store.dispatch

export default store
